import { useState } from 'react';
import { Store, Cpu, Trophy, ShieldCheck, UserPlus, Construction, Loader2, Save } from 'lucide-react';
import { toast } from 'sonner';
import { Switch } from '../ui/switch';
import { Input } from '../ui/input';
import { usePlatform } from '../BrandProvider';
import { api } from '../../lib/api';

const FLAGS = [
  ['enablePublicStore', Store, 'Store pubblico', 'Vetrina visibile ai giocatori. Se spento, la home mostra un avviso.'],
  ['enableGameStudio', Cpu, 'Game Studio', 'Vault e Studio IA nell\'Area Riservata. Il lucchetto resta per accedere ad Admin.'],
  ['enableGlobalLeaderboard', Trophy, 'Classifiche', 'Classifica globale nelle pagine dei giochi.'],
  ['enableLegalFooter', ShieldCheck, 'Note legali nel footer', 'Link Privacy / Termini e disclaimer in fondo allo Store.'],
  ['enableUserRegistration', UserPlus, 'Registrazione giocatori', 'Nuovi account con email. Gli account esistenti restano attivi.'],
  ['maintenanceMode', Construction, 'Modalità manutenzione', 'I giocatori vedono solo il messaggio di manutenzione.'],
];

export default function FeaturesPanel() {
  const { features, setFeatures } = usePlatform();
  const [d, setD] = useState(features);
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { setFeatures(await api('/admin/features', { method: 'PUT', body: d, auth: true })); toast.success('Sezioni aggiornate per tutti'); } catch (e) { toast.error(e.message); }
    setBusy(false);
  };
  return (
    <div data-testid="admin-features" className="space-y-3">
      {FLAGS.map(([k, Icon, title, desc]) => (
        <label key={k} className="glass rounded-2xl p-4 flex items-center gap-4 cursor-pointer">
          <Icon className={`h-5 w-5 shrink-0 ${k === 'maintenanceMode' ? 'text-amber-300' : 'text-cyan-300'}`} />
          <div className="flex-1 min-w-0"><div className="text-sm font-bold text-slate-100">{title}</div><div className="text-[11px] text-slate-400 t-chat">{desc}</div></div>
          <Switch data-testid={`flag-${k}`} checked={!!d[k]} onCheckedChange={(v) => setD({ ...d, [k]: v })} />
        </label>
      ))}
      {d.maintenanceMode && <Input data-testid="flag-maintenance-notice" value={d.maintenanceNotice} maxLength={240} onChange={(e) => setD({ ...d, maintenanceNotice: e.target.value })} placeholder="Messaggio di manutenzione" />}
      <button data-testid="features-save-btn" onClick={save} disabled={busy} className="flex items-center gap-2 rounded-full px-5 py-2.5 text-sm font-bold bg-gradient-to-r from-violet-600 to-cyan-600 disabled:opacity-50">
        {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Save className="h-4 w-4" />}Salva sezioni
      </button>
      <p className="text-[10px] text-slate-500 t-chat">L'Area Riservata (Admin e Config) resta sempre raggiungibile da /dev con il tuo PIN, anche con Studio o Store spenti.</p>
    </div>
  );
}
